import { Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SmallBtns({ txt, name, scrollTarget }) {
  const element = document.getElementById(scrollTarget);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (name) {
      navigate("/" + `${name}`);
      window.scrollTo(0, 0);
    }
    if (element) {
      element.scrollIntoView();
    }
  };
  return (
    <div>
      <Button
        sx={{
          bgcolor: "#C2E1FB",
          borderRadius: "10px",
          "&:focus": { color: "white", backgroundColor: "#638DEA" },
          "&:hover": { color: "white", backgroundColor: "#638DEA" },
        }}
        onClick={handleClick}
      >
        {t(txt)}
      </Button>
    </div>
  );
}
